<script setup lang="ts">
import type { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/vue-3';
import { Scissors, X } from 'lucide-vue-next';

const props = defineProps<NodeViewProps>();
</script>

<template>
    <!-- Read-only (print): an invisible real page break, no editing chrome. -->
    <NodeViewWrapper
        v-if="!props.editor?.isEditable"
        as="div"
        class="page-break-node-print"
        style="break-before: page; page-break-before: always"
    />

    <NodeViewWrapper
        v-else
        as="div"
        class="page-break-node node-insert-animate group my-2 flex items-center gap-2 py-1 select-none"
        data-drag-handle
    >
        <div
            class="h-px flex-1 border-t border-dashed border-muted-foreground/30"
        />
        <span
            class="flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-medium text-muted-foreground/50 ring-1 ring-muted-foreground/20"
        >
            <Scissors class="h-2.5 w-2.5" />
            Saut de page
        </span>
        <div
            class="h-px flex-1 border-t border-dashed border-muted-foreground/30"
        />
        <button
            class="hidden rounded p-0.5 text-muted-foreground/40 group-hover:flex hover:bg-destructive/10 hover:text-destructive"
            title="Supprimer le saut de page"
            @click="props.deleteNode()"
        >
            <X class="h-3 w-3" />
        </button>
    </NodeViewWrapper>
</template>
